import React from 'react';
import GenerateField from 'components/GenerateField';
import PropTypes from 'prop-types';
import { TAXREGISTRATION } from 'constants/companies';
import ReadOnlyRadioGroup from 'components/ReadOnlyRadioGroup';

const PeriodicVATReturns = ({ taxRegistration }) => {
  const fiedls = [
    {
      component: ReadOnlyRadioGroup,
      componentProps: {
        name: 'periodicVATReturns',
        options: TAXREGISTRATION.periodicVATReturns,
        value: taxRegistration.periodic_VAT_returns,
      },
    },
  ];

  return (
    <GenerateField
      name="periodicVATReturns"
      configs={fiedls}
      readOnly
      label="company.periodic_vat_returns.title"
    />
  );
};

PeriodicVATReturns.propTypes = {
  taxRegistration: PropTypes.object,
};
export default PeriodicVATReturns;
